import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteReminderSubjectSaga,
  getReminderSubjectDetailsSaga,
  getReminderSubjectListSaga,
} from "src/store/reminder-subjects/saga";
import {
  ReminderSubjectDetailDto,
  ReminderSubjectDto,
} from "src/store/reminder-subjects/type";
import ReminderSubjectCreateForm from "./create";
import ReminderSubjectEditForm from "./edit";

const ReminderSubjectsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<ReminderSubjectDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ReminderSubjectDetailDto>();

  const columns = [
    { text: t("ReminderSubject.Name"), dataField: "Name" },
    { text: t("ReminderSubject.ModuleType"), dataField: "ModuleTypeName" },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("ReminderSubject.PageTitle")}
        metaTag={t("ReminderSubject.PageTitle")}
        gridProps={{
          addTitle: t("ReminderSubject.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getReminderSubjectListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id: string) => {
              dispatch(
                getReminderSubjectDetailsSaga({
                  id,
                  payload: {
                    onSuccess: (_m: string, payload: any, response: any) => {
                      const obj = payload;
                      obj.Translates = response.Translates;
                      setSelected(obj);
                      setShowEdit(true);
                    },
                    onError: () => {},
                  },
                })
              );
            },
          },
          deleteButton: {
            text: (_id: string, row: ReminderSubjectDto) =>
              t("ReminderSubject.DeleteConfirm", { name: row.Name }).toString(),
            action: deleteReminderSubjectSaga,
            onClick: () => {},
          },
        }}
      />
      <ReminderSubjectCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch,
            message: m,
            action: getReminderSubjectListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ReminderSubjectEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch,
              message: m,
              action: getReminderSubjectListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ReminderSubjectsPage;
